// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as JsxRuntime from "react/jsx-runtime";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";

function UpdateIntentOverlay(props) {
  let isUpdateIntentLoading = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.isUpdateIntentLoading);
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  return JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
    condition: isUpdateIntentLoading,
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          className: "w-6 h-6 animate-spin rounded-full border-3 border-black/10 border-t-black/60"
        }),
        JsxRuntime.jsx("div", {
          children: match.localeString.refreshingText,
          className: "text-fs-13 text-black/55 tracking-[0.2px]"
        })
      ],
      className: "absolute inset-0 flex flex-col items-center justify-center gap-2 backdrop-blur-sm bg-white/40 z-[999] rounded-[inherit]"
    })
  });
}

let make = UpdateIntentOverlay;

export {
  make,
}
/* jotai Not a pure module */
